<template>
    <div>
        <v-data-table
        hide-default-footer
        :headers="headers"
        :items="tableValue"
        >
        <template v-slot:item.name="props">
            <v-edit-dialog
            :return-value.sync="props.item.name"
            >
            {{ props.item.name }}
            <template v-slot:input>
                <v-text-field
                v-model="props.item.name"
                label="Edit"
                single-line
                counter
                expand-icon="picture_as_pdf"
                ></v-text-field>
            </template>
            </v-edit-dialog>
        </template>
        <template v-slot:item.status="{ item }">
            <color-marker 
                v-model="statusColor"
                :color="item.statusColor"
            />
            {{ item.status }}
		    </template>
        <template v-slot:item.type="{ item }">
            <span class="pdfIcon material-icons-outlined">picture_as_pdf</span>
		    </template>
        </v-data-table>
    </div>
</template>  

<script>
import colorMarker from '@/components/ui/color-marker.vue'
import profil from '../../../../data/profil.json'


    export default {
  components: { colorMarker },
    data () {
      return {
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        headers: profil.settings.InvoiceTableHeaders,
        tableValue: this.$store.state.profil.settings.historyInvoice.tableValue, 
      }
    },
    computed: {
      statusColor() {
        this.tableValue.map((item) => {
          if(item.status === 'Payée'){ item.statusColor =  'green'}
          else if(item.status === 'En cours'){item.statusColor = 'orange'}
          else if (item.status === 'Erreur') {item.statusColor = 'red'}
        });
      },
   },
  }
</script>

<style lang="scss">
    table > thead > tr:last-child > th {
        color: $purple-alt !important;
    }
    .pdfIcon {
      color: $icon-purple;
    }
</style>
